import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import ScrollTop from './components/ScrollTop';
import { createRoot } from 'react-dom/client';
import "./locales/i18n";
const container = document.getElementById('root');
const root = createRoot(container);
root.render(
  <BrowserRouter>
    <ScrollTop />
    <App />
  </BrowserRouter>
);